"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDto = void 0;
const ImportedCustomerProfileDto_1 = require("../imported-customer-profiles/ImportedCustomerProfileDto");
const ClientDto_1 = require("../clients/ClientDto");
class AppDto {
    constructor(params) {
        this.name = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.bundleIdentifier = "";
        this.twitterConsumerKey = "";
        this.twitterConsumerSecret = "";
        this.classification = "";
        this.facebookAppId = "";
        this.appStoreAppId = "";
        this.appStoreIconUrl = "";
        this.beaconUuid = "";
        this.analyticsReportEmail = "";
        this.welcomeScreenTitle = "";
        this.welcomeScreenText = "";
        this.chooseALocationScreenTitle = "";
        this.homeScreenTitle = "";
        this.loyaltyRewardsProgramType = "";
        this.loyaltyRewardsTermsAndConditions = "";
        this.titleFor700CreditScreen = "";
        this.termsAndConditionsFor700Credit = "";
        this.privacyPolicyFor700Credit = "";
        this.askForSsnInCaseOfNoHitFor700Credit = false;
        this.extraGanAccountIds = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.name = params.name;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.bundleIdentifier = params.bundleIdentifier;
        this.twitterConsumerKey = params.twitterConsumerKey;
        this.twitterConsumerSecret = params.twitterConsumerSecret;
        this.classification = params.classification;
        this.facebookAppId = params.facebookAppId;
        this.appStoreAppId = params.appStoreAppId;
        this.appStoreIconUrl = params.appStoreIconUrl;
        this.beaconUuid = params.beaconUuid;
        this.analyticsReportEmail = params.analyticsReportEmail;
        this.welcomeScreenTitle = params.welcomeScreenTitle;
        this.welcomeScreenText = params.welcomeScreenText;
        this.chooseALocationScreenTitle = params.chooseALocationScreenTitle;
        this.homeScreenTitle = params.homeScreenTitle;
        this.loyaltyRewardsProgramType = params.loyaltyRewardsProgramType;
        this.loyaltyRewardsTermsAndConditions =
            params.loyaltyRewardsTermsAndConditions;
        this.titleFor700CreditScreen = params.titleFor700CreditScreen;
        this.termsAndConditionsFor700Credit = params.termsAndConditionsFor700Credit;
        this.privacyPolicyFor700Credit = params.privacyPolicyFor700Credit;
        this.askForSsnInCaseOfNoHitFor700Credit =
            params.askForSsnInCaseOfNoHitFor700Credit;
        this.extraGanAccountIds = params.extraGanAccountIds;
        if (params.client !== undefined) {
            this.client = params.client === null ?
                null :
                new ClientDto_1.ClientDto(params.client);
        }
        if (params.importedCustomerProfile !== undefined) {
            this.importedCustomerProfile = !params.importedCustomerProfile ?
                [] :
                params.importedCustomerProfile.map((importedCustomerProfileDto) => new ImportedCustomerProfileDto_1.ImportedCustomerProfileDto(importedCustomerProfileDto));
        }
    }
}
exports.AppDto = AppDto;
//# sourceMappingURL=AppDto.js.map